import { WatchQueryFetchPolicy } from '@apollo/client';

export interface IPolicesResponse {
  fetchPolicy?: WatchQueryFetchPolicy;
  nextFetchPolicy?: WatchQueryFetchPolicy;
}

export const getPolices = (fromCache?: boolean | string): IPolicesResponse => {
  if (fromCache === 'cache') {
    return {
      fetchPolicy: 'cache-only',
    };
  }

  if (fromCache === 'cache-and-network') {
    return {
      fetchPolicy: 'cache-and-network',
    };
  }

  if (fromCache === 'cache-first') {
    return {
      fetchPolicy: 'cache-first',
    };
  }

  if (fromCache) {
    return {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    };
  }

  return {
    fetchPolicy: 'network-only',
  };
};
